// extracted by css-extract-rspack-plugin
export default {"Box":"archive-list-item-module__Box__UCACs"};